import { Chip, styled } from '@mui/material';

/** Grid pill selection: the union view or a single formatter family. */
export type FormatterTypePill = 'all' | 'numeric' | 'text' | 'date' | 'boolean';

export const FORMATTER_PILLS: FormatterTypePill[] = ['all', 'numeric', 'text', 'date', 'boolean'];

const PILL_LABEL: Record<FormatterTypePill, string> = {
  all: 'All',
  numeric: 'Numeric',
  text: 'Text',
  date: 'Date',
  boolean: 'Boolean',
};

const Wrapper = styled('div')`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.5rem;
`;

interface FormatterTypePillsProps {
  selected: FormatterTypePill;
  onChange: (pill: FormatterTypePill) => void;
}

/** Pattern mirrors FieldTypePills in src/pages/AdminPanel/FieldManager. */
export function FormatterTypePills({ selected, onChange }: FormatterTypePillsProps) {
  return (
    <Wrapper>
      {FORMATTER_PILLS.map((pill) => {
        const isSelected = pill === selected;
        return (
          <Chip
            key={pill}
            label={PILL_LABEL[pill]}
            onClick={() => onChange(pill)}
            variant={isSelected ? 'filled' : 'outlined'}
            color={isSelected ? 'primary' : 'default'}
          />
        );
      })}
    </Wrapper>
  );
}

export function pillMatchesFormatterType(pill: FormatterTypePill, type: string | undefined): boolean {
  switch (pill) {
    case 'numeric':
      return type === 'number' || type === 'currency';
    case 'text':
      return type === 'string';
    case 'date':
    case 'boolean':
      return type === pill;
    default:
      return true;
  }
}
